// Map quality (Auto, 144p, 240p, etc.) to legacy quality (low, medium, high) for old videos
export const mapQualityToLegacy = (quality: string): string => {
  if (quality === "Auto") return "medium"; // Auto defaults to medium for legacy
  if (quality === "144p" || quality === "240p") return "low";
  if (quality === "360p" || quality === "480p") return "medium";
  if (quality === "720p") return "high";
  return "medium"; // default
};

// Get video URL based on hlsProcessed flag and quality
export const getVideoURL = (
  baseURL: string,
  videoID: string,
  hlsProcessed: boolean,
  quality: string
): string => {
  if (hlsProcessed) {
    // HLS video - use master.m3u8 for Auto, specific quality otherwise
    if (quality === "Auto") {
      return `${baseURL}video/hls/${videoID}/master.m3u8`;
    }
    return `${baseURL}video/hls/${videoID}/${quality}/index.m3u8`;
  }
  // Legacy video - map quality to low/medium/high
  const legacyQuality = mapQualityToLegacy(quality);
  return `${baseURL}video/getVideo?watch=${videoID}&quality=${legacyQuality}`;
};

// Always return the same quality options for all videos
export const getQualityOptions = (): string[] => {
  return ["Auto", "144p", "240p", "360p", "480p", "720p"];
};
